/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Not_Found_DescInputs */

const en_resumes_not_found_desc = /** @type {(inputs: Resumes_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This resume may have been deleted or moved.`)
};

const de_resumes_not_found_desc = /** @type {(inputs: Resumes_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Lebenslauf wurde möglicherweise gelöscht oder verschoben.`)
};

const fr_resumes_not_found_desc = /** @type {(inputs: Resumes_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce CV a peut-être été supprimé ou déplacé.`)
};

const es_resumes_not_found_desc = /** @type {(inputs: Resumes_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este currículum puede haber sido eliminado o movido.`)
};

const it_resumes_not_found_desc = /** @type {(inputs: Resumes_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo curriculum potrebbe essere stato eliminato o spostato.`)
};

const nl_resumes_not_found_desc = /** @type {(inputs: Resumes_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit CV is mogelijk verwijderd of verplaatst.`)
};

const pl_resumes_not_found_desc = /** @type {(inputs: Resumes_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To CV mogło zostać usunięte lub przeniesione.`)
};

const fi_resumes_not_found_desc = /** @type {(inputs: Resumes_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä ansioluettelo on saatettu poistaa tai siirtää.`)
};

const da_resumes_not_found_desc = /** @type {(inputs: Resumes_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette CV er muligvis blevet slettet eller flyttet.`)
};

const sv_resumes_not_found_desc = /** @type {(inputs: Resumes_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detta CV kan ha raderats eller flyttats.`)
};

/**
* | output |
* | --- |
* | "This resume may have been deleted or moved." |
*
* @param {Resumes_Not_Found_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_not_found_desc = /** @type {((inputs?: Resumes_Not_Found_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Not_Found_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_not_found_desc(inputs)
	if (locale === "fr") return fr_resumes_not_found_desc(inputs)
	if (locale === "es") return es_resumes_not_found_desc(inputs)
	if (locale === "it") return it_resumes_not_found_desc(inputs)
	if (locale === "nl") return nl_resumes_not_found_desc(inputs)
	if (locale === "pl") return pl_resumes_not_found_desc(inputs)
	if (locale === "fi") return fi_resumes_not_found_desc(inputs)
	if (locale === "da") return da_resumes_not_found_desc(inputs)
	if (locale === "sv") return sv_resumes_not_found_desc(inputs)
	return en_resumes_not_found_desc(inputs)
});